<!-- 团队签到 -->
<template>
  <ul class="pz_one qd_one">
    <li>
      <input
        v-model="formData.teamField"
        type="text"
        class="txt"
        placeholder="团体名称"
      />
    </li>
    <li>
      <a-button :loading="btnLoading" class="btnNext" @click="search">查询</a-button>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    btnLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: {
        alias: this.$route.query.alias,
        signId: this.$route.query.configuration,
        signMode: "Team",
        teamField: "",
      },
    };
  },
  methods: {
    async search() {
      if (this.formData.teamField === "") {
        this.$message.warning("请输入查询条件");
        return;
      }
      this.$emit("search", this.formData);
    },
  },
};
</script>
